<template>
  <div class="login-form">
    <div class="row" v-if="isTrade">
      <div class="col">
        <p>
          Customers who have already registered for online access, please login
          here.
        </p>
      </div>
    </div>
    <b-overlay :show="loading" :rounded="false" bg-color="white">
      <b-alert :show="message !== false" variant="danger"
        ><div v-html="message"></div
      ></b-alert>
      <b-form @submit.prevent="doLogin">
        <b-form-group
          id="input-group-username"
          label="Email address:"
          label-for="input-username"
        >
          <b-form-input
            id="input-username"
            v-model="user_login"
            @keyup.enter="doLogin"
            type="email"
            placeholder="Enter email"
            required
          ></b-form-input>
        </b-form-group>

        <b-form-group
          id="input-group-password"
          label="Password:"
          label-for="input-password"
        >
          <b-form-input
            @keyup.enter="doLogin"
            id="input-password"
            v-model="user_password"
            type="password"
            placeholder="Enter password"
            required
          ></b-form-input>
        </b-form-group>
      </b-form>

      <div class="mt-2 text-center">
        <b-button @click="doLogin" variant="success" v-if="showButton"
          >Log in</b-button
        >
      </div>
    </b-overlay>
  </div>
</template>

<script>
/* global gtag */

export default {
  props: {
    showButton: {
      type: Boolean,
      default: false,
    },
    doRedirect: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      user_login: "",
      user_password: "",
      remember: false,
      message: false,
      loading: false,
    };
  },
  methods: {
    doLogin() {
      this.loading = true;
      this.message = false;
      return this.$store
        .dispatch("user/login", {
          user_login: this.user_login,
          user_password: this.user_password,
          remember: this.remember,
        })
        .then((response) => {
          if (!response.data.status) {
            this.message = response.data.msg;
          } else if (response.data.redirect) {
            gtag("event", "login", {
              method: "Jeroboams Account",
            });
            window.location = response.data.redirect;
          }
          return response;
        })
        .finally((response) => {
          this.loading = false;
          return response;
        });
    },
  },
};
</script>